import './NotFound.scss';
import { useMemo } from 'react';
import { Page } from '@Components/Page';
import { useAppSelector } from '../../redux';
import * as UserRedux from '../../redux/user';
import { useCompanyInfo } from '../../utils/hooks/useCompanyInfo';
import { useLocationCompany } from '../../utils/hooks/useLocationCompany';

export const NotFound = () => {
  const locationCompany = useLocationCompany();
  const companyInfo = useCompanyInfo();
  const allUserCompanies = useAppSelector(UserRedux.companiesSelector);
  const { href } = window.location;

  const userHasAccessToCompany = useMemo(
    () => allUserCompanies.map(company => company.company).includes(locationCompany ?? ''),
    [allUserCompanies, locationCompany]
  );

  const message = useMemo(() => {
    // The company in the URL does not exist
    if (locationCompany && !companyInfo) {
      return `"${locationCompany}" is not a valid locationCompany. This was the url you used.`;
    }
    // The company in the URL exists, but user does not have access
    if (locationCompany && companyInfo && !userHasAccessToCompany) {
      return `You do not have access to "${locationCompany}", please reach out to a member of that team to provide you access.`;
    }
    return "This page doesn't exist.";
  }, [companyInfo, locationCompany, userHasAccessToCompany]);

  return (
    <Page title='Page Not Found' pageType='Page Not Found'>
      <div className='page-not-found'>
        <div className='message'>{message}</div>
        <code className='href'>{href}</code>
      </div>
    </Page>
  );
};
